$(document).ready(function(){

	$('a[href^="#"]').on('click', function(e){
		
		e.preventDefault();
		var id = $(this).attr("href");

		if (id == '#cookie-policy') {
			tarteaucitron.userInterface.openPanel();

		} else {
			$('html, body').animate({
				scrollTop: $(id).offset().top - $('.header__navbar').outerHeight()
			}, 'slow');
			$(id).focus();
			return false;
		}
	});

});